import { useDispatch, useSelector } from "react-redux";
import RenderDocumentation from "../../components/Documentation/RenderDocumentaion";
import SideBarMenu from "../../components/Documentation/SideBarMenu";
import {
  documentationContent,
  newDocumentationContent,
} from "./documentationContent";
import { useEffect, useRef, useState } from "react";
import RightSideBarMenu from "../../components/Documentation/RightSideBarMenu";
import {
  handleClose,
  handleDocSearchModal,
  setSidebarWidth,
} from "../../store/reducers/reducer-sidebar";
import DocSearchModal from "../../components/Documentation/DocSearch/DocSearchModal";
import { matchedResults } from "./utils";
import DocSearchComp from "../../components/Documentation/DocSearch/DocSearchComp";
import Topbar from "./Topbar";
import { LiHandleButton } from "../../Utils/CustomComponent";
import VideoResources from "../../components/Videos";

const Documentation = () => {
  const [activeTab, setActiveTab] = useState(0);

  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const { showDocSearch, isLargeDevice } = useSelector(
    (state) => state.RS_Sidebar
  );
  const [selectedSection, setSelectedSection] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const contentRef = useRef(null);
  const dispatch = useDispatch();
  const { sidebarWidth } = useSelector((state) => state.RS_Sidebar);

  // const filteredDocumentationContent = newDocumentationContent?.filter(
  //   (section) => section.role === selectedRole
  // );

  const filteredDocumentationContent = newDocumentationContent
    ?.filter(
      (section) =>
        section.role.find((role) => role === selectedRole) === selectedRole
    )
    ?.map((doc, idx) => {
      return {
        ...doc,
        index: idx,
      };
    });

  const handleSectionClick = (index) => {
    setSelectedSection(index);
  };

  const handlePrevClick = () => {
    if (selectedSection > 0) {
      setSelectedSection(selectedSection - 1);
    }
  };

  const handleNextClick = () => {
    if (selectedSection < filteredDocumentationContent.length - 1) {
      setSelectedSection(selectedSection + 1);
    }
  };

  const closeDocSearch = () => {
    dispatch(handleDocSearchModal(false));
    setSearchResults([]);
    setSearchQuery("");
  };

  const handleDocSearch = async (section) => {
    const res = filteredDocumentationContent.find(
      (section1) => section1.section === section.section
    );

    if (selectedSection !== res.index) {
      setSelectedSection(res.index);
    }
    const sectionId = await (section.subHeading !== ""
      ? section.id
      : section.headingId);

    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
    closeDocSearch();
  };

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [selectedSection]);

  // useEffect(() => {
  //   dispatch(setSidebarWidth("100px"));
  //   // dispatch(handleClose())
  // }, []);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setSearchResults([]);
      return;
    }
    const debouncedSearch = setTimeout(() => {
      const results = matchedResults(filteredDocumentationContent, searchQuery);
      setSearchResults(results);
    }, 800);

    return () => clearTimeout(debouncedSearch);
  }, [searchQuery]);

  return (
    <div
      className="text-start container-fluid my-0 px-0 docsearch"
      style={{ overflowY: "scroll", background: "#eeeeee", position: "fixed" }}
    >
      <ul className="nav nav-tabs mt-4 px-5">
        {tabButtons.map((data, index) => (
          <LiHandleButton
            key={index}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            label={data.label}
            value={index}
            handleBtnClick={setActiveTab}
          />
        ))}
      </ul>

      <section
        className="rounded py-5 d-flex"
        style={{
          background: "#eeeeee",
          // minHeight: "100vh",
          height: "87vh",
          position:
            filteredDocumentationContent.length > 0 && activeTab === 0
              ? "fixed"
              : "unset",
          width: isLargeDevice ? "-webkit-fill-available" : null,
          overflow: "scroll",
        }}
      >
        <article
          className="container row"
          style={{
            position: "sticky",
            overflow: "auto",
            top: "9rem",
            // bottom: "0.25rem",
          }}
        >
          {activeTab === 0 ? (
            <>
              {isLargeDevice ? (
                <div
                  className={`col-auto col-md-3`}
                  style={{
                    position: "sticky",
                    // top: 0,
                    top: "5rem",
                    height: "100vh",
                    overflowY: "auto",
                  }}
                >
                  <SideBarMenu
                    sectionData={documentationContent}
                    onSectionClick={handleSectionClick}
                    selectedSection={selectedSection}
                    selectedRole={selectedRole}
                  />
                </div>
              ) : (
                <div
                  className={`col-auto col-md-1`}
                  style={{
                    position: "fixed",
                    right: "1rem",
                    height: "100vh",
                    overflowY: "auto",
                    zIndex: "1000",
                  }}
                >
                  <Topbar>
                    <SideBarMenu
                      sectionData={documentationContent}
                      onSectionClick={handleSectionClick}
                      selectedSection={selectedSection}
                      selectedRole={selectedRole}
                      className={"text-center"}
                    />
                  </Topbar>
                </div>
              )}
              <div
                className={`${
                  isLargeDevice ? "col-7" : "col-8"
                } rounded bg-white`}
                ref={contentRef}
                style={{ overflowY: "auto", height: "100vh" }}
                // style={{ overflowY: "auto", height: "100vh" }}
              >
                <RenderDocumentation
                  documentationContent={filteredDocumentationContent}
                  selectedSection={selectedSection}
                  selectedRole={selectedRole}
                />
                <div className="d-flex justify-content-between p-3">
                  <button
                    onClick={handlePrevClick}
                    disabled={selectedSection === 0}
                    className="btn btn-primary"
                  >
                    Previous
                  </button>
                  <button
                    onClick={handleNextClick}
                    disabled={
                      selectedSection ===
                      filteredDocumentationContent.length - 1
                    }
                    className="btn btn-primary"
                  >
                    Next
                  </button>
                </div>
              </div>
              {filteredDocumentationContent?.length ? (
                <div
                  className={`${isLargeDevice ? "col-2" : "col-4"}`}
                  style={{
                    position: "sticky",
                    // top: 0,
                    top: "3rem",
                    height: "100vh",
                    overflowY: "auto",
                  }}
                >
                  <RightSideBarMenu
                    sectionData={filteredDocumentationContent}
                    onSectionClick={handleSectionClick}
                    selectedSection={selectedSection}
                    selectedRole={selectedRole}
                  />
                </div>
              ) : null}
            </>
          ) : (
            <VideoResources position="fixed" />
          )}
        </article>
      </section>
      <DocSearchModal
        showDocSearch={showDocSearch}
        closeDocSearch={closeDocSearch}
        setSearchQuery={setSearchQuery}
        searchQuery={searchQuery}
        content={
          <DocSearchComp
            searchResults={searchResults}
            handleDocSearch={handleDocSearch}
            searchQuery={searchQuery}
          />
        }
      />
    </div>
  );
};
export default Documentation;

const tabButtons = [
  { label: <p>Documentation</p>, title: "Documentation", key: 0 },
  { label: <p>Video Resources</p>, title: "Video Resources", key: 1 },
];
